import { useMemo, useEffect } from "react";
import { Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { toPng } from "html-to-image";
import DownloadGraphButton from "../../../../user/pages/page/DownloadGraphButton";

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);
const DynamicRadarChart = ({ data, myhandleExport, remark }) => {
  const chartID = `customer_sub_radar_${data?.dimensionName.replace(/\s+/g, "_")}`;
  // Memoized Chart Data
  const chartData = useMemo(
    () => ({
      labels: data.chartData.labels,
      datasets: data.chartData.datasets,
    }),
    [data.chartData]
  );

  // Memoized Chart Options
  const options = useMemo(
    () => ({
      responsive: true,
      plugins: {
        legend: {
          position: "top",
        },
      },
      scales: {
        r: {
          suggestedMin: 0,
          suggestedMax: 5,
          ticks: {
            stepSize: 1,
          },
        },
      },
    }),
    []
  );

  // Function to Capture Image and Store in Local Storage
  const generateHtmlImage = async (id, remarkValue) => {
    const node = document.getElementById(id);
    if (!node) return;

    try {
      const imgURI = await toPng(node);
      const chartData = JSON.parse(localStorage.getItem("chartImageData")) || [];

      const updatedChartData = chartData.map((item) => {
        if (item.id === "customer_sub_radar") {
          const subImageIndex = item.subimage.findIndex((sub) => sub.id === id);
          const updatedSubimages =
            subImageIndex !== -1
              ? item.subimage.map((sub, index) =>
                  index === subImageIndex ? { ...sub, image: imgURI } : sub
                )
              : [...item.subimage, { id, image: imgURI }];

          return { ...item, subimage: updatedSubimages, remark: remarkValue };
        }
        return item;
      });

      localStorage.setItem("chartImageData", JSON.stringify(updatedChartData));
    } catch (error) {
      console.error("Error generating image from HTML:", error);
    }
  };

  // Capture Image after Chart Rendering
  useEffect(() => {
    const timer = setTimeout(() => {
      generateHtmlImage(chartID, remark);
    }, 500);

    return () => clearTimeout(timer);
  }, [chartID, remark]);


  return (
    <div
      style={{ marginBottom: "40px" }}
      data-heading="Sub - Dimensions Radar charts"
      data-remark={remark}
      className={`chart17-${data.dimensionName}`}
      id={chartID}
    >
      <div className="d-flex justify-content-between">
        <h5>{data.dimensionName}</h5>
        <DownloadGraphButton chartID={`chart17-${data.dimensionName}`} myhandleExport={myhandleExport} />
      </div>
      <div style={{ height: "450px" }} className="tex d-flex justify-content-center">
        <Radar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default DynamicRadarChart;
